import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3w2x2jy6xw: FaireBrandEntity = {
  token: "b_3w2x2jy6xw",
  type: "brand",
  name: "Radiant Sun Botanicals",
  avatarUrl:
    "https://cdn.faire.com/fastly/70a9d162ceeb011a0cb4a0c8320f1bb13d765da4b5644a39a97f019b73850970.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/bdfdd0cb2ae9cbce093304e1ebf0c411632b4e4c71cbaa9c329f42c56e53c365.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/70a9d162ceeb011a0cb4a0c8320f1bb13d765da4b5644a39a97f019b73850970.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bdfdd0cb2ae9cbce093304e1ebf0c411632b4e4c71cbaa9c329f42c56e53c365.jpeg",
  location: "Forest , VA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 6,
  isInsider: true,
  description:
    "The creation of Radiant Sun Botanicals was a spiritually-guided process.  My name is Stephanie Kraft and I am an energy healer and hypnotherapist.  Through a series of events, I was Divinely guided to create this company.  I infuse all of my products with my healing energy so that my products are extra healing.  I started out by creating the best whipped body butter in the world in 2015.  I spent 9 months perfecting my recipes.  After that, I created many more products.  The creative process for me never ends and new products are always being created.  I source the worlds most exotic butters and oils and the highest quality essential oils for my products.  The quality speaks for itself in how my products make you feel.  They are truly luxurious!    ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:19.266Z",
    importedBy: "entity-db-cli",
  },
};
